import cx from 'classnames';
import React, { useState } from 'react';
/**
 * 让包裹的组件支持响应事件及样式
 */
export function Clickable(_a) {
    var children = _a.children, _b = _a.element, Wrapper = _b === void 0 ? 'div' : _b, className = _a.className, activeClassName = _a.activeClassName, onClick = _a.onClick;
    var _c = useState(false), touchDown = _c[0], setTouchDown = _c[1];
    return (React.createElement(Wrapper, { onTouchStart: function () { return setTouchDown(true); }, onTouchEnd: function () { return setTouchDown(false); }, onTouchCancel: function () { return setTouchDown(false); }, onClick: onClick, className: cx(className, touchDown && activeClassName) }, children));
}
